import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './UserFormLabelTranslation.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('user-form-label');
addTranslations(translations);

export const useUserFormLabelTranslation = useTranslation;
